import React from "react";
import {Box, Stack, Typography} from "@mui/material"
import {SnackbarContent, CustomContentProps} from "notistack";
import CircularProgress from "@mui/material/CircularProgress";

const ProcessInProgressSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
	const {id, message, ...other} = props;

	return(
		<SnackbarContent ref={ref} role="alert" {...other}>
			<Stack
				gap={2}
				direction="row"
				sx={{
					padding: "5px 10px",
					width: "320px",
					height:"54px",
					alignItems: "center",
					backgroundColor: "#2C2C2C",
					borderRadius: "4px",
					border: "1px solid #A1A1A026",
					boxSizing: "border-box"
				}}
			>
				<Box sx={{width: "25px", height: "25px"}}>
					<CircularProgress size="25px" />
				</Box>
				<Typography
					sx={{
						fontSize: "14px",
						fontWeight: 600,
						color: "white"
					}}
				>
					{message}
				</Typography>
			</Stack>
		</SnackbarContent>
	)
});

ProcessInProgressSnackbar.displayName = "BuildingReportSnackbar";

export default ProcessInProgressSnackbar;